jQuery(function ($) {
        if ($('.boughto.boughto_wheel_package_tyre_results').length) {

            var current_request = false;
            getResults();

            function getResults(filters = {}) {
                if (current_request) {
                    return;
                }

                current_request = true;

                $.each(filters, function (key, value) {
                    if (Array.isArray(value)) {
                        new_value = "";
                        $.each(value, function (id, name) {
                            if (new_value != "") {
                                new_value += ',';
                            }
                            new_value += name;
                        });
                        filters[key] = new_value;
                    }
                });

                $('.default_filters').each(function () {
                    if (filters[$(this).attr('name')] === undefined) {
                        filters[$(this).attr('name')] = $(this).val();
                    }
                });

                updateUrlPrams(filters);

                filters['action'] = 'post_get_tyre_results';

                jQuery.ajax({
                    url: boughto.ajax_url,
                    type: 'post',
                    data: filters,
                    dataType: 'json',
                    beforeSend: function () {
                        $('.loading').show();
                        $('.boughto_wheel_package_tyre_results .bp-page').addClass('is-busy');
                    },
                    complete: function () {
                        $('.boughto_wheel_package_tyre_results .bp-page').removeClass('is-loading is-busy');
                    },
                    success: function (response) {

                        if (response.hasOwnProperty('data')) {
                            response = response.data;

                            // results
                            $('.boughto_results_tyres').html(response.results_html);
                            $('.lazy').Lazy({chainable: false});

                            // pagination
                            $('.boughto_results_pagination').html(response.pagination_html);

                            // Newer template parts: each only exists in templates that render its container.
                            $('.boughto_tyre_tiers').html(response.tiers_html || '');
                            renderFilters(response.filters);
                            resetRail();

                            checkFiltersChanged();
                        } else {
                            // var ret = "<option value='-1'>No " + model.data("name") + " Found</option>";
                            // model.html(ret);
                        }

                        $('.loading').show();
                        current_request = false;
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        $('.loading').hide();
                        current_request = false;

                        // var ret = "<option value='-1'>Error Loading " + model.data("name") + "!</option>";
                        // model.html(ret);
                    }
                });
            }

            var $root = $('.boughto.boughto_wheel_package_tyre_results').first();

            function setDefaultFilter(name, value) {
                var $input = $root.find('.default_filters[name="' + name + '"]');
                if (!$input.length) {
                    $input = $('<input type="hidden" class="default_filters">').attr('name', name).prependTo($root);
                }
                $input.first().val(value);
                $root.find('.default_filters[name="_page"]').val(1);
            }

            function refresh() {
                var $form = $root.find('form.boughto_results_filters').first();
                if ($form.length) {
                    updateForm($form);
                } else {
                    getResults({});
                }
            }

            function renderFilters(filters) {
                if (!filters) return;
                $.each(filters, function (name, data) {
                    var $target = $root.find('.' + data.class + '_desktop');
                    if (!$target.length || !data.data || !data.data.options) return;

                    if ($target.is('select')) {
                        var $select = $target.empty().append($('<option value="">').text($target.data('label')));
                        $.each(data.data.options, function (key, filter) {
                            var value = filter.value !== undefined ? filter.value : filter.key;
                            $select.append($('<option>').val(value).text(filter.key)
                                .prop('selected', data.data.selected + '' === value + ''));
                        });
                        return;
                    }

                    var html = '';
                    $.each(data.data.options, function (key, filter) {
                        var value = filter.value !== undefined ? filter.value : filter.key;
                        var checked = data.data.selected + '' === value + '' ? 'checked' : '';
                        html += '<div class="flex items-center">' +
                            '<input ' + checked + ' id="filter-p-' + data.name + '-' + filter.key + '" name="' + data.name + '" value="' + value + '" type="' + data.type + '" class="h-4 w-4 border-gray-300 rounded text-boughto_primary_action_hex focus:ring-boughto_primary_action_hex">' +
                            '<label for="filter-p-' + data.name + '-' + filter.key + '" class="ml-3 text-sm text-gray-600">' + filter.key + '</label></div>';
                    });
                    $target.html(html);
                });
            }

            $(document).on('change', '.boughto_tier_input', function () {
                setDefaultFilter('tier', this.value);
                refresh();
            });

            $(document).on('click', '.boughto_tier_clear', function () {
                setDefaultFilter('tier', '');
                refresh();
            });

            // Package card: picking a tyre fills the card; its button submits that tyre's add-to-cart form.
            var $rail = $root.find('.boughto_build_rail'),
                railDefaults = {
                    slot: $rail.find('.boughto_build_rail_tyre').html(),
                    name: $rail.find('.boughto_build_rail_tyre_name').text(),
                    total: $rail.find('.boughto_build_rail_total').text()
                };

            function resetRail() {
                if (!$rail.length) return;
                $rail.find('.boughto_build_rail_tyre').removeClass('is-filled').html(railDefaults.slot);
                $rail.find('.boughto_build_rail_tyre_name').text(railDefaults.name).closest('li').attr('data-state', 'empty');
                $rail.find('.boughto_build_rail_total').addClass('is-placeholder').text(railDefaults.total);
                $rail.find('.boughto_build_rail_buy').prop('disabled', true);
            }

            function pickTyre($card) {
                if (!$rail.length) return;
                var image = $card.data('image');
                var $slot = $rail.find('.boughto_build_rail_tyre').addClass('is-filled').empty();
                if (image) $slot.append($('<img alt="">').attr('src', image));
                $rail.find('.boughto_build_rail_tyre_name').text($card.data('name')).closest('li').removeAttr('data-state');
                $rail.find('.boughto_build_rail_total').removeClass('is-placeholder').text($card.data('total'));
                $rail.find('.boughto_build_rail_buy').prop('disabled', !$card.find('.add-to-cart form').length);
            }

            $(document).on('change', '.boughto_tyre_pick', function () {
                pickTyre($(this).closest('.boughto_tyre_card'));
            });

            $(document).on('click', '.bp-option', function (e) {
                if ($(e.target).closest('input, label, a, button, select').length) return;
                var $pick = $(this).find('.boughto_tyre_pick');
                if (!$pick.prop('disabled')) $pick.prop('checked', true).trigger('change');
            });

            $(document).on('click', '.boughto_build_rail_buy', function () {
                var $form = $root.find('.boughto_tyre_pick:checked').closest('.boughto_tyre_card').find('.add-to-cart form');
                if ($form.length) $form.trigger('submit');
            });

            function updateUrlPrams(filters) {
                const url = new URL(window.document.URL);
                $.each(filters, function (key, value) {

                    if(key == "chassis_id") return;
                    if(key == "package_price") return;
                    if(key == "package_quantity") return;

                    url.searchParams.set(key, value);
                });

                window.history.replaceState(null, "", url.toString());
            }

            function checkFiltersChanged() {
                $('.boughto_tyre_results').each(function () {
                    var $self = $(this);

                    $self.find('.boughto_sort_button').click(function () {
                        $self.find('form.boughto_results_filters').each(function () {
                            updateForm($(this))
                        });
                    })

                    $self.find('form.boughto_results_filters').each(function () {
                        var $form = $(this);
                        var filters = 'input[name="range_name"], input[name="speed_rating"], input[name="wet_grip"], input[name="fuel_efficiency"], input[name="noise_decibel"], input[name="noise_rating"], select.bp-filter';

                        $form.find(filters).unbind();
                        $form.find(filters).change(function () {
                            updateForm($form)
                        });
                    });
                });
            }

            function updateForm($form) {
                // Checkbox groups, or the default template's single-choice selects.
                function chosen(name) {
                    return $form.find('input[name="' + name + '"]:checked, select[name="' + name + '"]').filter(function () {
                        return $(this).val() !== '';
                    });
                }

                var range_name = chosen('range_name'),
                    speed_rating = chosen('speed_rating'),
                    wet_grip = chosen('wet_grip'),
                    fuel_efficiency = chosen('fuel_efficiency'),
                    noise_decibel = chosen('noise_decibel'),
                    noise_rating = chosen('noise_rating');

                getResults({
                    range_name: range_name.map(function () {
                        return $(this).val();
                    }).get(),
                    speed_rating: speed_rating.map(function () {
                        return $(this).val();
                    }).get(),
                    wet_grip: wet_grip.map(function () {
                        return $(this).val();
                    }).get(),
                    fuel_efficiency: fuel_efficiency.map(function () {
                        return $(this).val();
                    }).get(),
                    noise_decibel: noise_decibel.map(function () {
                        return $(this).val();
                    }).get(),
                    noise_rating: noise_rating.map(function () {
                        return $(this).val();
                    }).get(),
                });
            }
        }
    }
);